import React from 'react';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';

export default function Tracking({conNumber}) {

	const [ posts, setPosts ] = useState([]);
	const [inavlid,setInvalid] = useState(false)
	useEffect(() => {
		try{
		fetch('https://ac55csbe9h.execute-api.ap-south-1.amazonaws.com/v1/consignments/'+conNumber)
			.then((response) => response.json())
			.then((data) => {
				console.log(data);
				if(data.conNo){
					data.history && data.history.forEach(element => {
						if(element.collDate)
							element.collDate=element.collDate.replaceAll(".","-").replaceAll("/","-")
						if(element.updateTime)
							element.updateTime =moment(element.updateTime).format("DD-MM-YYYY HH:mm:ss")
					});
					if(data.collDate)
					data.collDate=data.collDate.replaceAll(".","-").replaceAll("/","-")
					setPosts([data]);
				}else
					setInvalid(true)
				    

			})
			.catch((err) => {
				console.log(err.message);
				setPosts([]);
			});
		}catch(e){
			setPosts([]);
		}
	}, []);

	return (
		<div >
			<div className='min-h-screen'>
			<div className="items-center justify-center w-full flex flex-col mt-10 ">
				
				<h2 class="text-2xl font-semibold leading-tight mb-5 ">Track Your Shipment</h2>
				
				{inavlid?(<p className='text-red-700 mb-2'>Invalid Consignment Number: {conNumber}</p>):(<p className=' mb-2'>Consignment Number : {conNumber}</p>)} 

				

				<button class="px-4 text-white bg-blue-600  rounded-full p-1 " >
				<Link to="../../" relative="path"> Back to Home </Link>
				</button>

				{/* <div class="flex border-2 border-gray-200 w-96 rounded rounded-3xl shadow-2xl">
					<input
						type="text"
						class="px-6 py-4  rounded-3xl  outline-blue-500/50 w-96 rounded-r-none"
						placeholder="Search..."
					/>
					<button class="px-4 text-white bg-blue-600 border-l  rounded-r-3xl">Search</button>
				</div> */}
			</div>
			<div className="flex flex-col  items-center justify-center">
				<div class="w-5/6 px-4 sm:px-8 ">
					<div class="py-8">
						<div />
            {posts && posts.length>0 && posts.map((post) => {
                  return (
						<div class="-mx-4  sm:-mx-8 px-4 sm:px-8 py-4 overflow-x-auto">
							<div class="inline-block min-w-full shadow-md rounded-lg overflow-hidden">


							<table class="min-w-full leading-normal table lg:hidden shadow border">
									<tbody>
										<tr>
											<th class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
												Coll Date
											</th>
											<td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
												<p class="text-gray-900 whitespace-no-wrap">{post.collDate}</p>
												<p class="text-gray-600 whitespace-no-wrap" />
											</td>
										 </tr>
										 <tr>
											<th class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
												Job No
											</th>
											<td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
												<p class="text-gray-900 whitespace-no-wrap">{post.jobNo}</p>
											</td>
											</tr>
										 <tr>
											<th class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
												Con No
											</th>
											
											<td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
												<p class="text-gray-900 whitespace-no-wrap"> {post.conNo}</p>
											</td>
											</tr>
										 <tr>
											<th class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
												Shipper
											</th>
											
											<td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
												<p class="text-gray-900 whitespace-no-wrap">{post.shipper}</p>
											</td>
											</tr>
										 <tr>
											<th class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
												Consignee
											</th>
											
											<td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
												<p class="text-gray-900 whitespace-no-wrap">{post.consignee}</p>
											</td>
											</tr>
										 <tr>
											<th class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
												No Of Pkg
											</th>
											<td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
												<p class="text-gray-900 whitespace-no-wrap">{post.noOfPkg}</p>
											</td>
											</tr>
										 <tr>
											<th class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
												Weight
											</th>
											
											<td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
												<p class="text-gray-900 whitespace-no-wrap">{post.weight}</p>
											</td>
											</tr>
										 <tr>
											<th class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
												Charges
											</th>
											<td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
												<p class="text-gray-900 whitespace-no-wrap">{post.charges}</p>
											</td>
											</tr>

										 <tr>
											<th class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
												Final Location
											</th>
											<td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
												<p class="text-gray-900 whitespace-no-wrap">{post.finalLocation} </p>
											</td>
											</tr>
										 <tr>
											<th class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
												Status
											</th>
											<td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
												<span class="relative inline-block px-3 py-1 font-semibold text-green-900 leading-tight">
													<span
														aria-hidden
														class="absolute inset-0 bg-green-200 opacity-50 rounded-full"
													/>
													<span class="relative">{post.status}</span>
												</span>
											</td>

										</tr>
									</tbody>
									
								</table>
								
             
								<table class="min-w-full leading-normal hidden lg:block">
									<thead>
										<tr>
											<th class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
												Coll Date
											</th>
											<th class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
												Job No
											</th>
											<th class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
												Con No
											</th>
											<th class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
												Shipper
											</th>
											<th class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
												Consignee
											</th>
											<th class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
												No Of Pkg
											</th>
											<th class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
												Weight
											</th>
											<th class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
												Charges
											</th>
											<th class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
												Final Location
											</th>
											<th class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
												Status
											</th>
										</tr>
									</thead>
									<tbody>
										<tr>
											<td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
												<p class="text-gray-900 whitespace-no-wrap">{post.collDate}</p>
												<p class="text-gray-600 whitespace-no-wrap" />
											</td>
											<td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
												<p class="text-gray-900 whitespace-no-wrap">{post.jobNo}</p>
											</td>
											<td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
												<p class="text-gray-900 whitespace-no-wrap"> {post.conNo}</p>
											</td>
											<td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
												<p class="text-gray-900 whitespace-no-wrap">{post.shipper}</p>
											</td>
											<td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
												<p class="text-gray-900 whitespace-no-wrap">{post.consignee}</p>
											</td>
											<td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
												<p class="text-gray-900 whitespace-no-wrap">{post.noOfPkg}</p>
											</td>
											<td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
												<p class="text-gray-900 whitespace-no-wrap">{post.weight}</p>
											</td>
											<td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
												<p class="text-gray-900 whitespace-no-wrap">{post.charges}</p>
											</td>
											<td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
												<p class="text-gray-900 whitespace-no-wrap">{post.finalLocation} </p>
											</td>
											<td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
												<span class="relative inline-block px-3 py-1 font-semibold text-green-900 leading-tight">
													<span
														aria-hidden
														class="absolute inset-0 bg-green-200 opacity-50 rounded-full"
													/>
													<span class="relative">{post.status}</span>
												</span>
											</td>
											
										</tr>
									</tbody>
								</table>
                
							</div>

							<div className="mt-10 shadow-md ">
								<table class="min-w-full leading-normal ">
									<thead>
										<tr className=" ">
                    <th class="px-5 py-3 border-b-2 border-gray-200 bg-green-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
												Collection Date
											</th>
											<th class="px-5 py-3 border-b-2 border-gray-200 bg-green-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
												Updated Date
											</th>
											{/* <th class="px-5 py-3 border-b-2 border-gray-200 bg-green-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
												Updated By
											</th> */}
											{/* <th class="px-5 py-3 border-b-2 border-gray-200 bg-green-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
												Description
											</th> */}
											{/* <th class="px-5 py-3 border-b-2 border-gray-200 bg-green-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
												Final Location
											</th>
											<th class="px-5 py-3 border-b-2 border-gray-200 bg-green-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
												Whatsapp Number
											</th> */}
											<th class="px-5 py-3 border-b-2 border-gray-200 bg-green-100 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider">
												Status
											</th>
										</tr>
									</thead>
									<tbody>


                    {
                     post && post.history.map((item,i)=>{

                        return <tr>
                          <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                            <p class="text-gray-900 whitespace-no-wrap">{item.collDate}</p>
                            <p class="text-gray-600 whitespace-no-wrap" />
                          </td>
                          <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                            <p class="text-gray-900 whitespace-no-wrap">{item.updateTime}</p>
                          </td>
                          
                          <td class="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                            <span class="relative inline-block px-3 py-1 font-semibold text-green-900 leading-tight">
                              <span
                                aria-hidden
                                class="absolute inset-0 bg-green-200 opacity-50 rounded-full"
                              />
                              <span class="relative">{item.status}</span>
                            </span>
                          </td>
                          
                        </tr>


                      })
                    }
                   
									</tbody>
								</table>
							</div>
						</div>
              );
            })}
					</div>
          
				</div>
			</div>
		</div>
		</div>
		
	);
}
